import { render, staticRenderFns } from "./UiEarnings.vue?vue&type=template&id=07bc6940&"
import script from "./UiEarnings.vue?vue&type=script&lang=js&"
export * from "./UiEarnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports